import React from "react";
import workingOnIt from "../../assets/working-on-it.gif";
import "./Travel.scss";

const Travel = () => {
  return (
    <div className="travel-container">
      <img className="travel-gif" src={workingOnIt} alt="Working on it" />
    </div>
  );
};

export default Travel;
